<template>
  <div>
    <vue-headful
      title="Class Homework | School Dashboard"
      description="Description goes here"
    />
    <div class="class-homework-section sub-type-layout">
      <div class="container px-1">
        <div class="row">
          <!-- CLASS BRANCH INFO COLUMN -->
          <div class="col-12 col-md-3 col-lg-3 left-left-layout">
            <!-- MEMBERS CARD COMPONENT -->
            <MembersCard @updateTeacher="num_counter++">
              <!-- LOADER -->
              <div
                class="loader d-flex justify-content-center align-items-center my-4"
                v-if="teacher_count === null"
              >
                <div class="avatar">
                  <span
                    class="icon-dotted-spinner flex-center font-22 border_grey_dark animate mr-2"
                  ></span>
                </div>
                <div class="border_grey_dark font-13">Loading Teachers ...</div>
              </div>
              <!-- LOADER -->

              <div slot="teacher__content" v-else>
                <!-- CONTENT TEACHER LIST -->
                <MembersTeacherRow
                  v-if="teacher_count > 0"
                  :teachers_list="teacher_data"
                  @toggleTeacher="toggleTeacherModal"
                ></MembersTeacherRow>

                <!-- EMPTY TEACHER LIST -->
                <div class="teacher-list-empty mb-3">
                  <MembersEmptyTeacherRow
                    v-if="teacher_count === 0"
                    @toggleTeacher="toggleTeacherModal"
                  ></MembersEmptyTeacherRow>
                </div>
              </div>
            </MembersCard>
            <!-- MEMBERS CARD COMPONENT -->
          </div>
          <!-- CLASS BRANCH INFO COLUMN -->

          <!-- CLASS HOMEWORK -->
          <div class="col-12 offset-md-0 col-md-8 col-lg-9 right-layout">
            <!-- PAGE TITLE -->
            <div
              class="title-row d-flex justify-content-between align-items-center nowrap"
            >
              <!-- TITLE -->
              <div class="page-title font-weight-bold color_text">
                Assessment
              </div>
              <!-- ADD NEW -->
              <div
                class="avatar avatar_sm_md btn-accent pointer"
                v-if="false"
                @click="toggleNewAssessmentModal"
              >
                <span class="flex-center icon-plus font-19"></span>
              </div>
            </div>

            <!-- CONTENT INFO AND DEFAULT COMPONENTS -->
            <transition name="fade" mode="out-in">
              <keep-alive>
                <component
                  :is="in_view"
                  :is_empty="is_empty"
                  :is_loading="is_loading"
                  :homeworks="homeworks"
                  :pagination="pagination"
                  @show-alert="showAlert"
                  @switchPage="navigatePage($event)"
                ></component>
              </keep-alive>
            </transition>
            <!-- CONTENT INFO AND DEFAULT COMPONENTS -->
          </div>
          <!-- CLASS HOMEWORK -->
        </div>
      </div>
    </div>

    <component
      :is="modalType + 'HomeworkModal'"
      v-if="school_modal"
      @close-triggered="school_modal = false"
      @closeTriggered="school_modal = false"
      @action="performAction"
      :modalType="modalType"
      :show_alert="show_alert"
      :alert_type="alert_type"
      :alert_msg="alert_msg"
      :details="details"
    ></component>

    <!-- ADD TEACHER MODAL -->
    <NewAssessmentModal
      v-if="new_assessment_modal"
      @closeTriggered="toggleNewAssessmentModal"
    ></NewAssessmentModal>

    <AddTeacherModal
      v-if="teacher_modal"
      @closeTriggered="toggleTeacherModal"
    ></AddTeacherModal>
    <!-- ADD TEACHER MODAL -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TeachersInClass from "@/scripts/mixins/TeachersInClass";
import MembersCard from "@/components/classComps/studentSideBar/MembersCard";
import MembersEmptyTeacherRow from "@/components/classComps/studentSideBar/MembersEmptyTeacherRow";
import DefaultInfo from "@/components/classComps/homework/DefaultInfo";
import { setTimeout } from "timers";

const MembersTeacherRow = () => ({
  /* webpackChunkName: "MembersTeacherRow" */
  component: import("@/components/classComps/studentSideBar/MembersTeacherRow"),
  loading: MembersEmptyTeacherRow,
  error: MembersEmptyTeacherRow,
  delay: 500,
  timeout: 10000,
});

export default {
  name: "ClassHomework",

  mixins: [TeachersInClass],

  components: {
    MembersCard,
    MembersEmptyTeacherRow,
    MembersTeacherRow,
    DefaultInfo,
    ContentInfo: () =>
      import(
        /* webpackChunkName: "ContentInfo" */
        "@/components/classComps/homework/ContentInfo"
      ),
    NewAssessmentModal: () =>
      import(
        /* webpackChunkName: "NewAssessmentModal" */
        "@/components/modalComps/assessmentModals/NewAssessmentModal"
      ),
    AddTeacherModal: () =>
      import(
        /* webpackChunkName: "AddTeacherModal" */
        "@/components/modalComps/schoolModals/AddTeacherModal"
      ),
    ExtendHomeworkModal: () =>
      import(
        /* webpackChunkName: "UpdateAssessmentDates" */
        "@/components/modalComps/assessmentModals/UpdateAssessmentDates"
      ),
    RestartHomeworkModal: () =>
      import(
        /* webpackChunkName: "AssessmentModal" */
        "@/components/modalComps/teacherModals/assessmentModals/Restart"
      ),
    DeleteHomeworkModal: () =>
      import(
        /* webpackChunkName: "AssessmentModal" */
        "@/components/modalComps/teacherModals/assessmentModals/Delete"
      ),
    UpdateHomeworkModal: () =>
      import(
        /* webpackChunkName: "UpdateAssessmentDates" */
        "@/components/modalComps/assessmentModals/UpdateAssessmentModal"
      ),
  },

  data() {
    return {
      in_view: "DefaultInfo",
      new_assessment_modal: false,
      teacher_modal: false,
      school_modal: false,
      modalType: "",

      homework_count: 0,
      homeworks: [],
      pagination: {
        pageCount: 0,
      },

      show_alert: true,
      alert_type: "",
      alert_msg: "",

      is_empty: false,
      is_loading: true,

      class_id: "",
    };
  },

  watch: {
    homework_count: "updateView",
    $route: {
      handler(newVal) {
        if (newVal) this.fetchHomeworks();
      },
      immediate: true, // make this watch function is called when component created
    },
  },

  mounted() {
    this.setCurrentClass(this.$route.params.id);
  },

  methods: {
    ...mapActions([
      "setCurrentClass",
      "getHomeworks",
      "restartHomework",
      "deleteHomework",
      "extendHomeworkDate",
      "editHomeworkDetails",
    ]),

    updateView() {
      this.homework_count > 0
        ? (this.in_view = "ContentInfo")
        : (this.in_view = "DefaultInfo");
    },

    createNewAssessment() {
      this.$router.push({
        name: "CreateSchoolAssessment",
      });
    },

    fetchHomeworks(page = 1) {
      this.class_id = this.$route.params.id;
      this.homework_count = 0;
      this.homeworks = [];
      this.is_empty = false;
      this.is_loading = true;

      this.getHomeworks({
        account_type: "school",
        id: this.class_id,
        page: page,
      })
        .then((response) => {
          // console.log(response);
          if (response.code === 200 && response.data.length) {
            this.homework_count = response.data.length;
            this.homeworks = response.data;
            this.is_empty = false;
            this.is_loading = false;
            this.pagination = response.pagination;
          } else {
            setTimeout(() => {
              this.is_empty = true;
              this.is_loading = false;
            }, 1000);
          }
        })
        .catch((err) => console.log(err));
    },

    navigatePage(page) {
      this.fetchHomeworks(page);
    },

    toggleNewAssessmentModal() {
      this.new_assessment_modal = !this.new_assessment_modal;
    },

    showAlert(type, id) {
      const homework = [...this.homeworks].find(
        (homework) => homework.id == id
      );

      this.modalType = type;
      this.details = homework;
      this.school_modal = true;
    },

    performAction(form) {
      if (!form) return console.log(form);
      let action;
      // DETERMINE ACTION TO PERFORM
      switch (this.modalType.toLowerCase()) {
        case "restart":
          action = this.restartHomework;
          break;
        case "delete":
          action = this.deleteHomework;
          break;
        case "extend":
          action = this.extendHomeworkDate;
          break;
        case "update":
          action = this.editHomeworkDetails;
          break;
        default:
          action = location.reload;
          break;
      }

      // console.log("form restart", form);

      action(this.modalType.toLowerCase() == "delete" ? form.id : form).then(
        (res) => {
          if (res.code == 200) {
            this.relayMsg("success", res.message);
            if (
              ["update", "restart", "extend"].includes(
                this.modalType.toLowerCase()
              )
            ) {
              const former = this.homeworks;
              const index = this.homeworks.findIndex(
                (item) => item.id == res.data.id
              );
              this.homeworks[index] = res.data;
              this.homeworks = [];
              setTimeout(() => {
                this.homeworks = former;
              }, 500);
            } else if (this.modalType.toLowerCase() === "delete") {
              const index = this.homeworks.findIndex(
                (item) => item.id == form.id
              );
              setTimeout(() => {
                this.homeworks.splice(index, 1);
              }, 500);
            } else {
              this.fetchHomeworks();
            }
            // this.fetchHomeworks(this.class_id);
            setTimeout(() => {
              this.teacher_modal = false;
              //location.reload();
            }, 2000);
          } else if (!res.data) {
            this.relayMsg("danger", res.message);
          } else {
            this.relayMsg("danger", Object.values(res.data)[0]);
          }
        }
      );
    },

    relayMsg(type, message) {
      this.alert_type = type;
      this.alert_msg = message;
      this.show_alert = true;

      setTimeout(() => {
        this.show_alert = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss">
.class-homework-section {
  // PAGE TITLE
  .page-title {
    font-size: 22px;

    @include breakpoint_max(lg) {
      font-size: 20px;
    }

    @include breakpoint_max(sm) {
      font-size: 18px;
    }
  }

  .right-layout {
    @include breakpoint_max(lg) {
      width: 110% !important;
      right: -50px;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    @include breakpoint_max(md) {
      width: 100% !important;
      right: 0;
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }
}
</style>
